import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCrKTWODrpA7o-YPI8EsIZbzkzMcRYvc_o",
  authDomain: "sushikiug.firebaseapp.com",
  projectId: "sushikiug",
  storageBucket: "sushikiug.firebasestorage.app",
  messagingSenderId: "368029572139",
  appId: "1:368029572139:web:6f2dfcc087cfcd584ede6e",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');
export const submitQrOrder = httpsCallable(functions, 'submitQrOrder');
export const sendOTP = httpsCallable(functions, 'sendOTP');
export const verifyOTP = httpsCallable(functions, 'verifyOTP');
export const updateCustomerProfile = httpsCallable(functions, 'updateCustomerProfile');
export const getCustomerOrders = httpsCallable(functions, 'getCustomerOrders');
export const requestOrderOTP = httpsCallable(functions, 'requestOrderOTP');
export const verifyOrderOTP = httpsCallable(functions, 'verifyOrderOTP');
export const sendEmailCode = httpsCallable(functions, 'sendEmailCode');
export const verifyEmailCode = httpsCallable(functions, 'verifyEmailCode');
export const paypalCreateOrder = httpsCallable(functions, 'paypalCreateOrder');
export const paypalCaptureOrder = httpsCallable(functions, 'paypalCaptureOrder');
export const getOrderInvoicePdf = httpsCallable(functions, 'getOrderInvoicePdf');
